module.exports = "victory.png\nsize:388,347\nfilter:Linear,Linear\npma:true\nscale:0.5\nLogo_new_2\nbounds:2,2,384,343\noffsets:287,100,960,540\n"